import { Inject, Injectable } from '@angular/core';
import { BantaServiceChatBackend } from '@banta/client';
import { AuthenticationProvider, UserAccount } from '@banta/common';

@Injectable()
export class TYTBantaAuthenticationProvider implements AuthenticationProvider {
    validateToken(jwt: string): Promise<UserAccount> {
        throw new Error('Method not implemented.');
    }
    getUsersByUsernames(names: string[]): Promise<UserAccount[]> {
        throw new Error('Method not implemented.');
    }
    getUsersByIds(ids: string[]): Promise<UserAccount[]> {
        throw new Error('Method not implemented.');
    }
    getUserByUsername(username: string): Promise<UserAccount> {
        throw new Error('Method not implemented.');
    }
    getUserById(uid: string): Promise<UserAccount> {
        throw new Error('Method not implemented.');
    }

}